import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

/**
 * NavbarDesktop Component
 * 
 * Desktop version of the landing page navbar.
 * Exact copy of original Navbar with touch feedback added.
 */
const NavbarDesktop = () => {
  const { currentUser, userData } = useAuth();

  return (
    <nav className="navbar flex justify-between items-center px-12 py-6 max-w-[1400px] w-[calc(100%-4rem)] my-4 mx-auto relative z-navbar glass-bg-navbar rounded-navbar shadow-navbar min-h-[60px]">
      {/* Logo */}
      <Link to="/" className="logo font-semibold text-logo flex items-center gap-2 text-text-primary whitespace-nowrap flex-shrink-0 pr-8 no-underline">
        <span className="logo-icon font-bold lawnance-brand">LAWNANCE</span>
      </Link>

      {/* Navigation Links - Center, hidden on mobile */}
      <div className="nav-links hidden md:flex gap-12 absolute left-1/2 -translate-x-1/2 whitespace-nowrap px-4">
        <a
          href="#solutions"
          className="no-underline text-text-primary text-nav-link font-medium transition-opacity duration-300 hover:opacity-70 whitespace-nowrap py-1"
        >
          Solutions
        </a>
        <a
          href="#plans"
          className="no-underline text-text-primary text-nav-link font-medium transition-opacity duration-300 hover:opacity-70 whitespace-nowrap py-1"
        >
          Plans
        </a>
      </div>

      {/* Action Buttons - Right */}
      <div className="nav-actions flex-shrink-0 min-w-0 pl-8 flex gap-3">
        {currentUser ? (
          <div className="flex items-center gap-4">
            <span className="text-text-primary font-medium hidden lg:block">
              Welcome, {userData?.fullName || currentUser?.displayName || 'User'}
            </span>
            <Link
              to="/app"
              className="btn-primary bg-btn-bg text-btn-text border border-white/20 px-6 py-3 rounded-btn-primary text-nav-btn font-medium cursor-pointer transition-all duration-300 no-underline shadow-btn-primary hover:shadow-btn-primary-hover hover:-translate-y-0.5 active:scale-[0.98]"
              style={{
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }}
            >
              Go to App
            </Link>
          </div>
        ) : (
          <>
            <Link
              to="/login"
              className="btn-outline bg-transparent border border-white/20 px-6 py-3 rounded-btn-outline text-nav-btn font-medium cursor-pointer transition-all duration-300 no-underline text-text-primary hover:bg-white/10 hover:border-white/30 hover:-translate-y-0.5 hover:shadow-btn-outline-hover active:scale-[0.98]"
              style={{
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }}
            >
              Login
            </Link>
            <Link
              to="/register"
              className="btn-primary bg-btn-bg text-btn-text border border-white/20 px-6 py-3 rounded-btn-primary text-nav-btn font-medium cursor-pointer transition-all duration-300 no-underline shadow-btn-primary hover:shadow-btn-primary-hover hover:-translate-y-0.5 active:scale-[0.98]"
              style={{
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }}
            >
              Sign Up
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default NavbarDesktop;

